export type RoomCountLabelCopy = {
  roomCountLabel?: string
  roomCountLabelDouble?: string
  roomCountLabelOne?: string
}

/** Keys used by `roomTypes.filters` in i18n messages (RoomTypesFilterCopy). */
export type RoomTypesFilterRoomCountCopy = {
  roomsDouble?: string
  roomsMany?: string
  roomsOne?: string
}

export type RoomCountCopyInput = RoomCountLabelCopy | RoomTypesFilterRoomCountCopy

function resolveRoomCountCopy(copy: RoomCountCopyInput): RoomCountLabelCopy {
  if ('roomsOne' in copy || 'roomsDouble' in copy || 'roomsMany' in copy) {
    const filterCopy = copy as RoomTypesFilterRoomCountCopy
    return {
      roomCountLabelOne: filterCopy.roomsOne,
      roomCountLabelDouble: filterCopy.roomsDouble,
      roomCountLabel: filterCopy.roomsMany,
    }
  }

  return copy
}

/** 1 → Single room, 2 → Double room, 3+ → "{count} rooms". */
export function formatRoomCountLabel(
  roomCount: number,
  copy: RoomCountCopyInput,
): string {
  const labels = resolveRoomCountCopy(copy)
  if (roomCount === 1) {
    return labels.roomCountLabelOne ?? 'Single room'
  }

  if (roomCount === 2) {
    return labels.roomCountLabelDouble ?? 'Double room'
  }

  const template = labels.roomCountLabel ?? '{count} rooms'
  return template.replace('{count}', String(roomCount))
}

/** Filter checkbox labels for the Rooms facet. */
export function formatRoomCountFilterLabel(
  roomCount: number,
  copy: RoomCountCopyInput,
): string {
  return formatRoomCountLabel(roomCount, copy)
}
